<style >
	.demo-ruleForm .el-form-item__content {
		display: flex; flex-direction: row;
		margin-left: 0!important;
	}
	.demo-ruleForm .el-input {
		width: 220px!important;
	}
</style>

<template>
	<div>
		<el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="比赛ID">
				<el-input size="small" v-model="ruleForm.match_id"></el-input>
			</el-form-item>
			
			<el-form-item label="场次:">
				<el-input size="small" v-model="ruleForm.issue_week"></el-input>
			</el-form-item>
			
			<el-form-item label="客队VS主队:">
				<el-input size="small" v-model="ruleForm.short_away"></el-input>
				<div style="width: 30px; text-align: center;">:</div>
				<el-input size="small" v-model="ruleForm.short_home"></el-input>
			</el-form-item>
			<el-form-item label="全场比分:">
				<el-input size="small" v-model="odds.away_score"></el-input>
				<div style="width: 30px; text-align: center;">:</div>
				<el-input size="small" v-model="odds.home_score"></el-input>
			</el-form-item>
			
			<el-form-item label="胜负:">
				<el-input size="small" v-model="format.sf"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.sf}}</div>
			</el-form-item>
			
			<el-form-item label="让分胜负:">
				<el-input size="small" v-model="format.rf"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.rf}}</div>
			</el-form-item>
			
			<el-form-item label="大小分:">
				<el-input size="small" v-model="format.dxf"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.dxf}}</div>
			</el-form-item>
			
			<el-form-item label="胜分差:">
				<el-input size="small" v-model="format.sfc"></el-input>
				<div style="font-size: 14px; color: orangered;">{{odds.sfc}}</div>
			</el-form-item>
			
			<el-form-item>
				<el-button type="success" @click="getMatchData()">获取数据</el-button>
				<el-button type="primary" @click="submitApi()">保存发布</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
		computed:{
			teamVS(){
				return this.ruleForm.short_home + ' VS ' + this.ruleForm.short_away;
			}
		},
	    data() {
			return {
				odds:{
					home_score:'',
					away_score:'',
					sf:'',
					rf:'',
					sxf:'',
					sfc:''
				},
				format:{
					sf:'',
					rf:'',
					sxf:'',
					sfc:''
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			fotmatchMatchScore(_list){
				let _this = this;
				_list.forEach((row,key)=>{
					if(row.sectionNo == 1){
						let _exp = row.score.split(":");
						_this.odds.home_half_score = _exp[0];
						_this.odds.away_half_score = _exp[1];
					}
					if(row.sectionNo == 2){
						let _exp = row.score.split(":");
						_this.odds.home_score = _exp[0];
						_this.odds.away_score = _exp[1];
					}
				});
			},
			getedMatchResult(_result){
				console.log(_result);
				let _this = this;
				let _rs = '';
				let _rs1 = '';
				
				if(_result.sectionsNo999 && _result.sectionsNo999 != ''){
					let _exp = _result.sectionsNo999.split(":");
					if(_exp.length != 2){
						return _this.$message({
							 message: '赛果异常',
							 type: 'warning',
						});
					}
					_this.odds.away_score = _exp[0];
					_this.odds.home_score = _exp[1];
				}
				if(_result.mnlResultList && _result.mnlResultList.length > 0){
					let _resp = _result.mnlResultList[_result.mnlResultList.length - 1];
					_rs = _resp.combination == 'H' ? '主胜' : '主负';
					_this.format.sf = _rs + '@' + _resp.odds;
					_rs = _resp.combination == 'H' ? '3' : '0';
					_this.odds.sf = _rs + ',' + _resp.odds;
				}
				if(_result.hdcResultList && _result.hdcResultList.length > 0){
					let _resp = _result.hdcResultList[_result.hdcResultList.length - 1];
					_rs = _resp.combination == 'H' ? '让分主胜' : '让分主负';
					_this.format.rf = '(' + _resp.goalLine + ')' + _rs + '@' + _resp.odds;
					_rs = _resp.combination == 'H' ? '3' : '0';
					_this.odds.rf = _resp.goalLine + ',' +  _rs + ',' + _resp.odds;
				}
				if(_result.hiloResultList && _result.hiloResultList.length > 0){
					let _resp = _result.hiloResultList[_result.hiloResultList.length - 1];
					_rs = _resp.combination == 'H' ? '大' : '小';
					_this.format.dxf = '(' + _resp.goalLine + ')' + _rs + '@' + _resp.odds;
					_rs = _resp.combination == 'H' ? '1' : '0';
					_this.odds.dxf = _resp.goalLine + ',' +  _rs + ',' + _resp.odds;
				}
				if(_result.wnmResultList && _result.wnmResultList.length > 0){
					let _resp = _result.wnmResultList[_result.wnmResultList.length - 1];
					_this.format.sfc = _resp.combinationDesc + '@' + _resp.odds;
					
					switch(_resp.combinationDesc){
						case '主胜1-5': _rs = '7'; break;
						case '主胜6-10': _rs = '8'; break;
						case '主胜11-15': _rs = '9'; break;
						case '主胜16-20': _rs = '10'; break;
						case '主胜21-25': _rs = '11'; break;
						case '主胜26+': _rs = '12'; break;
						case '客胜1-5': _rs = '1'; break;
						case '客胜6-10': _rs = '2'; break;
						case '客胜11-15': _rs = '3'; break;
						case '客胜16-20': _rs = '4'; break;
						case '客胜21-25': _rs = '5'; break;
						case '客胜26+': _rs = '6'; break;
					}
					_this.odds.sfc = _rs + ',' + _resp.odds;
				}
			},
			cancelMatchResult(){
				let _this = this;
				_this.odds.home_score = 0;
				_this.odds.away_score = 0;
				
				_this.format.sf = '无效场次';
				_this.format.rf = '无效场次';
				_this.format.dxf = '无效场次';
				_this.format.sfc = '无效场次';
				
				_this.odds.sf = '*';
				_this.odds.rf = '*';
				_this.odds.dxf = '*';
				_this.odds.sfc = '*';
			},
			getMatchData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '获取中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/Sporttery/getBasketballResultApi?matchId=" + _this.ruleForm.match_id, {baseURL:'http://122.228.193.118:8877'}).then(res=>{
					loading.close();
					if(res.success)
					{
						if(res.value.matchResult == ''){
							return _this.$message({
								 message: '未公布赛果',
								 type: 'warning',
							});
						}else if(res.value.matchResult.sectionsNo999 && res.value.matchResult.sectionsNo999 == '无效场次'){
							_this.cancelMatchResult();
						}else{
							_this.getedMatchResult(res.value.matchResult);
						}
					}else{
						return _this.$message({
							 message: '获取数据失败，请重试（勿频繁点击）',
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '发布中..',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Open/saveBasketballResult", {match_id: _this.ruleForm.match_id, ..._this.odds}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '保存成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 90px;
	    height: 90px;
	    line-height: 90px;
	    text-align: center;
	  }
	  .avatar {
	    min-width: 90px;
	    height: 90px;
	    display: block;
	  }
</style>